// extracted by mini-css-extract-plugin
module.exports = {"container":"NoticeManager_container__29re5","placeHolder":"NoticeManager_placeHolder__3K39b"};